'use strict'

export const CREW_COLORS = [
  '#E50000', '#005CFF', '#008A00', '#111111',
  '#8A00E6', '#009FB7', '#FFB000', '#FF00A8',
  '#6B3F00', '#00D084', '#FF6D00', '#003A8C',
  '#A10035', '#6A00FF', '#5F7A00', '#00FFFF'
]

export function getCrewColor (crewId, crewIds) {
  const normalizedCrewId = String(crewId)
  const index = (crewIds || []).findIndex(item => String(item) === normalizedCrewId)
  if (index < 0) return '#9E9E9E'
  return CREW_COLORS[index % CREW_COLORS.length]
}

export function getRouteColor (routeId, routeIds) {
  const normalizedRouteId = String(routeId)
  const index = (routeIds || []).findIndex(item => String(item) === normalizedRouteId)
  if (index < 0) return '#9E9E9E'
  return CREW_COLORS[index % CREW_COLORS.length]
}

export default CREW_COLORS
